import { EEOccupationalLevel, SeverityLevel, DemographicGroup } from '../../../../Component/Model/Enum/EmploymentEquity';
import { DeviationsDto } from '../../../../Component/Model/Dto/EmploymentEquity/Deviations';
import { raceToDemographic, occupationalLevelDisplayNames, occupationalLevels } from '../Shared/deviationsCommon';
import { Gender, RaceTypes } from '../../../../Component/Model/Enum/BEE123Enums';

export { raceToDemographic, occupationalLevelDisplayNames, occupationalLevels };

export interface HeatMapCellData {
    id: string;
    occupationalLevel: EEOccupationalLevel;
    demographicGroup: DemographicGroup;
    race: RaceTypes;
    gender: Gender;
    target: number;
    targetCount: number;
    current: number;
    currentCount: number;
    gap: number;
    gapCount: number;
    gapPctRelative: number | null;
    severity: SeverityLevel;
    priorityRank: string | null;
}

export const designatedDemographics: DemographicGroup[] = [
    DemographicGroup.African_Male,
    DemographicGroup.Coloured_Male,
    DemographicGroup.Indian_Male,
    DemographicGroup.African_Female,
    DemographicGroup.Coloured_Female,
    DemographicGroup.Indian_Female,
    DemographicGroup.White_Female,
];

export const demographicGroups: DemographicGroup[] = [
    DemographicGroup.African_Male,
    DemographicGroup.Coloured_Male,
    DemographicGroup.Indian_Male,
    DemographicGroup.White_Male,
    DemographicGroup.African_Female,
    DemographicGroup.Coloured_Female,
    DemographicGroup.Indian_Female,
    DemographicGroup.White_Female,
    DemographicGroup.Foreign_National_Male,
    DemographicGroup.Foreign_National_Female,
];

export function mapCellsFromDto(cells: DeviationsDto.HeatmapCellDto[]): HeatMapCellData[] {
    return cells.flatMap(dto => {
        const demographicGroup = raceToDemographic[dto.raceId]?.[dto.genderId];
        if (!demographicGroup) return [];
        return [{
            id: `${dto.occupationalLevelId}-${dto.raceId}-${dto.genderId}`,
            occupationalLevel: dto.occupationalLevelId as EEOccupationalLevel,
            demographicGroup,
            race: dto.raceId as RaceTypes,
            gender: dto.genderId as Gender,
            target: dto.targetPercentage ?? 0,
            targetCount: dto.targetHeadcount,
            current: dto.currentPercentage ?? 0,
            currentCount: dto.currentHeadcount,
            gap: dto.gapPercentage ?? 0,
            gapCount: dto.gapHeadcount,
            gapPctRelative: dto.relativeGapPercentage,
            severity: dto.severityId as SeverityLevel,
            priorityRank: dto.priorityRank,
        }];
    });
}
